import { render, staticRenderFns } from "./baobiao.vue?vue&type=template&id=7bfacb43&scoped=true"
import script from "./baobiao.vue?vue&type=script&lang=js"
export * from "./baobiao.vue?vue&type=script&lang=js"
import style0 from "./baobiao.vue?vue&type=style&index=0&id=7bfacb43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfacb43",
  null
  
)

export default component.exports